export default __webpack_public_path__ + "static/media/28.41d5b29c.png";